<div class="layout-wrapper layout-content-navbar">
  <div class="layout-container">
    <app-side-nav></app-side-nav>

    <div class="layout-page">
      <div class="content-wrapper">
        <div class="container-xxl flex-grow-1 container-p-y">
          <div class="d-flex justify-content-between align-items-center py-3 mb-0" style="margin-top: -20px;">
            <h4 class="users-heading">
              <span class="text-muted fw-light">Data Extraction /</span> Subscriptions
            </h4>
            <!-- <button 
              class="btn custom-button" 
              [routerLink]="['/users/add']" 
              style="margin-bottom: -10px !important;">
              + Add User
            </button> -->
          </div>

          <div class="row mb-3 align-items-center">
            <div class="col-md-2 col-lg-3 me-2">
              <input 
                type="text" 
                placeholder="Search by name, mobile" 
                [(ngModel)]="searchText" 
                class="form-control" 
                (keydown.enter)="searchUsers()" />
            </div>

            <div class="col-md-2 me-2">
              <select [(ngModel)]="designationFilter" class="form-select">
                <option value="" disabled selected hidden>Filter Designation</option>
                <option value="CRO">CRO</option>
                <option value="CRC">CRC</option>
                <option value="PI">PI</option>
                <option value="Monitor">Monitor</option>
              </select>
            </div>

            <div class="col-md-3 me-2">
              <select [(ngModel)]="statusFilter" class="form-select">
                <option value="" disabled selected hidden>Filter By Status</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>

            <div class="col-md-auto d-flex">
              <button class="btn custom-button me-2" (click)="searchUsers()">Search</button>
              <button class="btn custom-button" (click)="clear()">Clear</button>
            </div>
          </div>

          <div *ngIf="loading" class="d-flex justify-content-center align-items-center" style="height: 150px;">
            <div class="spinner-border text-purple" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>

          <div class="card" *ngIf="!loading">
            <div class="table-responsive text-nowrap">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Mobile No</th>
                    <th style="text-align: center;">Email-ID</th>
                    <th>Designation</th>
                    <th style="text-align: center;">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let user of filteredData; let i = index">
                    <td>{{ user.name }}</td>
                    <td>{{ user.mobile }}</td>
                    <td>{{ user.email }}</td>
                    <td>{{ user.designation }}</td>
                    <td>
                      <span 
                        class="badge"
                        [ngClass]="{
                          'bg-label-success': user.status === 'Active', 
                          'bg-label-danger': user.status === 'Inactive'
                        }">
                        {{ user.status }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <br>

          <nav aria-label="Page navigation">
            <ul class="pagination"> 
              <li class="page-item" [class.disabled]="currentPage === 1">
                <a class="page-link" href="javascript:void(0);" (click)="prevPage()">Previous</a>
              </li>
            
              <li 
                *ngFor="let page of pageRange" 
                class="page-item" 
                [class.active]="page === currentPage">
                <a class="page-link" href="javascript:void(0);" (click)="goToPage(page)">{{ page }}</a>
              </li>
            
              <li class="page-item" [class.disabled]="currentPage === pages">
                <a class="page-link" href="javascript:void(0);" (click)="nextPage()">Next</a>
              </li>
            </ul>
          </nav>

          <hr class="my-5" />
        </div>
      </div>
    </div>
  </div>
</div>